import React from 'react';
import { MarketingChainWizard } from '../components/agents/marketingChain';
import useAuthStore from '../store/authStore';
import { Navigate } from 'react-router-dom';

const MarketingChainPage = () => {
    const { user } = useAuthStore();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    const handleComplete = (session) => {
        console.log('Marketing chain completed:', session);
        // Aquí puedes implementar la lógica para guardar el plan
        // o redirigir al usuario a otra página
    };

    const handleError = (error) => {
        console.error('Marketing chain error:', error);
        // Aquí puedes implementar el manejo de errores
        // como mostrar una notificación o redirigir
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <MarketingChainWizard
                userId={user.userId}
                onComplete={handleComplete}
                onError={handleError}
            />
        </div>
    );
};

export default MarketingChainPage; 